import { RuleAction } from '../enums/POR/RuleAction';
import { RuleOperation } from '../enums/POR/RuleOperation';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';
import { AWSRuleRegion } from '../enums/POR/AWSRuleRegion';

export default class AWSPortOpeningRule {
	id!: number;

	portOpeningRequestId!: number;

	action!: RuleAction;

	operation!: RuleOperation;

	description!: string;

	sourceIPs!: string;

	destinationIPs!: string;

	destinationURLs!: string;

	sourcePorts!: string;

	service!: string;

	name!: string;

	azureName!: string;

	direction!: PortOpeningRequestsDirection;

	destinationPorts!: { protocol: string; destinationPorts: string }[];

	region!: AWSRuleRegion;

	sendDND!: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.direction = new PortOpeningRequestsDirection().fromValue(obj.direction?.value);
	}
}